// @flow
// const API_URL: string = 'http://api.foobar.com';

// export const ARTIST_URL: string = `${API_URL}/artist/:id`;
// export const ARTIST_ALBUMS_URL: string = `${ARTIST_URL}/albums?limit=5`;

export const CM_SECURE_SUBSCRIBE_LINK: string = 'https://createsend.com//t/getsecuresubscribelink';

export const CM_COMPANY_DATA_ID: string = 'A61C50BEC994754B1D79C5819EC1255C869B54CD994DDB5A6FA5C7B116702EAAA7FAA6507BDF323439FAB011DD0890B8ADA01779A5310DB4D43DE8949E9F1727';
export const CM_COMPANY_FIELD_EMAIL: string = 'cm-etruhy-etruhy';

export const CM_FREELANCER_DATA_ID: string = 'A61C50BEC994754B1D79C5819EC1255C000303AEC370330AE818EFEA11A3103546310B13357C51C95B0A51EFFBB6D35576488A5DD84836EFFD9FB17E02CAD2C9';
export const CM_FREELANCER_FIELD_EMAIL: string = 'cm-syhkld-syhkld';
export const CM_FREELANCER_FIELD_NAME: string = 'cm-name';
export const CM_FREELANCER_FIELD_SPECIALISM: string = 'cm-f-jjljhyj';
export const CM_FREELANCER_FIELD_CATEGORY: string = 'cm-f-jjljhyt';
export const CM_FREELANCER_FIELD_PITCH: string = 'cm-f-jjljhyi';
export const CM_FREELANCER_FIELD_LINK_ONE: string = 'cm-f-jjljhyd';
export const CM_FREELANCER_FIELD_LINK_TWO: string = 'cm-f-jjljhyh';
export const CM_FREELANCER_FIELD_LINK_THREE: string = 'cm-f-jjljhyk';
